export default "__VITE_ASSET__Dr1plcD3__"